module.exports = __webpack_public_path__ + "img/IBM.20f938db.png";